import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { integrations, integrationPricing } from '../../data/pricingDetails';
import { addOnImages } from '../../data/pricingImages';
export function AddOnsGrid() {
  return <Section bordered labelledBy="addons-title" data-id="element-675" data-mp="2cvqzxl99ef3w">
      <Container data-id="element-676" data-mp="27xfstiacmipd">
        <Reveal data-id="element-677" data-mp="27xz5okl56gwj">
          <h2 id="addons-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-678" data-mp="27yhba7tp27h4">
            Add-Ons &amp; Integrations
          </h2>
          <p className="mt-6 max-w-[68ch] text-body text-muted" data-id="element-679" data-mp="1z5nhl5di35jq">
            The plans above cover standard informational websites. Any feature that adds complex
            functionality, monetary transactions, appointment scheduling, or third-party connectivity
            is quoted separately as an add-on, over and above the base plan price. This distinction is
            maintained so there is zero ambiguity regarding base deliverables.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4" data-id="element-680" data-mp="r3xox0ztadbo">
          {integrations.map((integration, index) => <Reveal as="li" key={integration.name} delay={index * 0.04} className="h-full" data-id="element-681" data-mp="cbvj70b28q3q" data-mpi={index}>
              <div className="group h-full rounded-card border border-hairline bg-canvas p-7 transition-[border-color,transform] duration-200 ease-out hover:-translate-y-1 hover:border-ink" data-id="element-682" data-mp="hdchco25tygm">
                <AppImage src={addOnImages[index].image} alt={addOnImages[index].alt} ratio="1:1" data-id="element-683" data-mp="1a18etuzjzueg" />
                <h3 className="mt-6 text-[18px] leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-684" data-mp="v47uwdnlt3qj">
                  {integration.name}
                </h3>
                <p className="mt-3 text-[14px] leading-6 text-[#6E6E6E]" data-id="element-685" data-mp="3fu70igh6f0pz">
                  {integration.description}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} data-id="element-686" data-mp="1rbkl0dtyhlwz">
          <div className="mt-6 rounded-card border border-hairline bg-[#F6F6F4] p-8" data-id="element-687" data-mp="1r9rgb42wlbrm">
            <p className="text-[32px] leading-none tracking-[-0.03em] text-ink" data-id="element-688" data-mp="1md10mhv0gi6q">
              {integrationPricing.price}
            </p>
            <p className="mt-5 max-w-[80ch] text-[14px] leading-6 text-[#6E6E6E]" data-id="element-689" data-mp="1hj6ivjyyudaa">
              {integrationPricing.note}
            </p>
          </div>
        </Reveal>
      </Container>
    </Section>;
}